import { CREATE_NEW_COLLECTION_KEY } from "@/modules/snapshots/modals/generateSnapshotCollectionModal/consts";
import { SnapshotCollection } from "@/modules/snapshots/snapshotCollection.types";
import { UseFormSetError } from "react-hook-form";

export const getSnapshotCollectionOptions = (snapshotCollections: SnapshotCollection[]) => [
  ...snapshotCollections
    .map(row => ({
      label: row.name,
      value: row.id,
    }))
    .sort((a, b) => a.label.localeCompare(b.label)),
  {
    label: "Create new collection",
    value: CREATE_NEW_COLLECTION_KEY,
  } as const,
];

export const validateSnapshotCollection = (
  selectedSnapshotCollection: string,
  payload: { snapshot_collection_new: string },
  setError: UseFormSetError<{ snapshot_collection_new: string }>,
) => {
  if (selectedSnapshotCollection === CREATE_NEW_COLLECTION_KEY && !payload.snapshot_collection_new) {
    setError("snapshot_collection_new", {
      type: "custom",
      message: "New snapshot collection name is required",
    });
    return false;
  }
  return true;
};
